import { ApiService } from './ApiService';

export const ApiDashboard = {
  dashboard: (userId: string) => `${ApiService.dashboard}?userId=${userId}`,
  getNotification: (userId: string, take?: number, page?: number) => `${ApiService.notification}?userId=${userId}&take=${take}&page=${page}`,
  readAllNotification: (userId: string) => `${ApiService.notification}/read-all?userId=${userId}`,
};
